import React, { createContext, useContext, useEffect, useState } from 'react';
import Keycloak, { KeycloakAdapter, KeycloakLoginOptions, KeycloakLogoutOptions, KeycloakRegisterOptions } from 'keycloak-js';
import { setKeycloakInstance, startTokenKeepAlive } from '../services/keycloakToken';

interface KeycloakContextType {
  keycloak: Keycloak | null;
  initialized: boolean;
  authenticated: boolean;
  token: string | undefined;
  login: () => void;
  logout: () => void;
}

const KeycloakContext = createContext<KeycloakContextType>({
  keycloak: null,
  initialized: false,
  authenticated: false,
  token: undefined,
  login: () => { },
  logout: () => { },
});

export const useKeycloak = () => useContext(KeycloakContext);


interface KeycloakProviderProps {
  children: React.ReactNode;
  keycloak: Keycloak;
}

export const KeycloakProvider: React.FC<KeycloakProviderProps> = ({ children, keycloak }) => {
  const [initialized, setInitialized] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState<string | undefined>();

  useEffect(() => {
    // Регистрируем экземпляр Keycloak для использования в API интерцепторах
    setKeycloakInstance(keycloak);

    keycloak
      .init({
        onLoad: 'check-sso',
        pkceMethod: 'S256',
        checkLoginIframe: false,
        // scope: 'openid profile cpda_scope email'
      })
      .then((authenticated) => {
        setAuthenticated(authenticated);
        setToken(keycloak.token);
        setInitialized(true);
      })
      .catch((error) => {
        console.error('Keycloak initialization failed:', error);
        setInitialized(true);
      });

    return startTokenKeepAlive((nextToken) => {
      setToken(nextToken);
      setAuthenticated(!!keycloak.authenticated);
    });
  }, [keycloak]);

  const login = () => {
    keycloak.login();
  };

  const logout = () => {
    keycloak.logout({ redirectUri: window.location.origin });
  };

  return (
    <KeycloakContext.Provider value={{ keycloak, initialized, authenticated, token, login, logout }}>
      {children}
    </KeycloakContext.Provider>
  );
};
